import EVisitsFeedItem from './e-visits-feed-item';

export default EVisitsFeedItem;
